module.exports = __webpack_public_path__ + "img/plus.c15fa7ac.svg";